import { useSyncExternalStore } from "react";

const STORAGE_KEY = "editor.vimMode";

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());

function getVimMode(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function setVimMode(enabled: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, String(enabled));
  } catch {
    // ignore
  }
  notify();
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useEditorSettings() {
  const vimMode = useSyncExternalStore(subscribe, getVimMode, () => false);
  return { vimMode, setVimMode };
}
